import { GetMonthNameByNumber } from "./GetMonthNameByNumber";

export const GetFechas = ({ ejercicioinicio, periodoinicio, ejerciciofin, periodofin }) => {
    var titulo = ''

    if (ejercicioinicio === ejerciciofin && periodoinicio === periodofin) {
        titulo = `${GetMonthNameByNumber(periodoinicio)} ${ejercicioinicio}`;
    } else if (ejercicioinicio === ejerciciofin) {
        titulo = `${GetMonthNameByNumber(periodoinicio)} a ${GetMonthNameByNumber(periodofin)} del ${ejercicioinicio}`;
    } else {
        titulo = `${GetMonthNameByNumber(periodoinicio)} ${ejercicioinicio} a ${GetMonthNameByNumber(periodofin)} ${ejerciciofin}`;
    }
    return titulo;
}

export const GetFechasSemanal = ({ ejercicio, periodo }) => {
    var titulo = ''
        titulo = `${GetMonthNameByNumber(periodo)} ${ejercicio}`;
    return titulo;
}